export const HelpAndLearningSections = {
  WELCOME: "WELCOME",
  GET_STARTED: "GET_STARTED",
  RULES_AND_REGULATIONS: "RULES_AND_REGULATIONS",
  CONTACTS_AND_SUPPORT: "CONTACTS_AND_SUPPORT",
  FAQS: "FAQS",
  ABOUT_US: "ABOUT_US",
  RESPONSIBLE_GAMING: "RESPONSIBLE_GAMING",
  TERMS_AND_CONDITIONS: "TERMS_AND_CONDITIONS",
  SELF_EXCLUSION: "SELF_EXCLUSION",
};
